import type { FC } from "react";
import type { INormalizedMatchEvent } from "@/types/normalizedMatchEvent";
import styles from "./MatchEventCard.module.scss";

import React from "react";
import { ImageWithSets } from "@/components/image-with-sets/ImageWithSets";
import classNames from "classnames";

const MatchEventCard: FC<{ matchEvent: INormalizedMatchEvent }> = ({
  matchEvent,
}) => {
  return (
    <>
      <div className={styles.matchEventsIcon}>
        <ImageWithSets image={matchEvent.icon} />
      </div>
      <div className={styles.matchEventsText}>
        {matchEvent.playerName === "" && (
          <p className="title-8-medium">{matchEvent.name}</p>
        )}
        <p className="title-8-medium">{matchEvent.playerName}</p>
        <p
          className={classNames(
            "title-8-regular",
            styles.matchEventsSecondaryText,
          )}
        >
          {matchEvent.metaText}
        </p>
      </div>
    </>
  );
};

export { MatchEventCard };
